import { getLinkDetailsEnterprise, toTitleCase } from "@/utils/utilities";
import { globalConstants } from "@/constants/globalConstants";

const MobileLocationDropdown = ({
  locationLinks,
  mobileChangeLocationLink,
  mobileSelectLocationLink,
  mobileLocationHeading,
  showLocationOperatingHours
}) => {

  const [viewAllHours, ...restLocationLinks] = locationLinks || [];
  const viewAllHoursDetails = getLinkDetailsEnterprise(viewAllHours);
  const midIndex = Math.ceil(restLocationLinks?.length / 2);
  const { IMAGES } = globalConstants?.olivegarden;


  return (
    <div className="location-dropdown mobile-location-information light-background" id="mobile-location-information">
      <div className="location-selected" id="mobile-selected-location" style={{ display: 'none' }}>
        <div className="location-dropdown__header">
          <h3 className="location-popup-title">{mobileLocationHeading}</h3>
        </div>
        <div className="location-dropdown__details">
          <div className="row mx-auto w-100 location-details__wrapper">
            <div className="location-dropdown__img col-4 px-0" data-name="Location for">
              <a id="popMapLink" className="trackContent"
                data-link-info="header|location dropdown|image click">
                <img
                  alt={IMAGES.MOBILE_DROPDOWN_MARKETING.IMAGE_ALT}
                  id="mapImgDyn"
                  src={IMAGES.MOBILE_DROPDOWN_MARKETING.IMAGE_URL}
                  className="d-block img-fluid mx-auto"
                />
              </a>
            </div>
            <div className="location-info location-dropdown__address col-8">
              <div><h3><a id="popRestNameLink"><span id="overlayRestName" className="location-name">NYC - Times Square</span></a></h3></div>
              <div>
                <p id="popRestAdd1" className="location-address">2 Times Square</p>
                <p className="location-address"><span id="popRestCity">New York,</span> <span id="popRestState">NY</span><span id="popRestZip">10036</span></p>
                <p id="popRestPhone" className="location-address">(212) 333-3254</p>
              </div>
            </div>
          </div>
          <div className="row mx-auto w-100 location-dropdown__hours">
            {showLocationOperatingHours && <div className="col-12 px-0">
              <div id="popRestHrs"></div>
            </div>}
            <div className="col-12 px-0">
              <a
                id={viewAllHoursDetails?.linkID}
                className="view-hours-link trackContent"
                href={viewAllHoursDetails?.linkUrl}
                target={viewAllHoursDetails?.linkTarget}
                
                data-link-info={viewAllHoursDetails?.dataLinkInfo}>{viewAllHoursDetails?.linkTitle}</a>
            </div>
          </div>
          <div className="location-divider"></div>

          <div className="location-actions">
            <div className="action-column">
              {restLocationLinks?.map((link, index) => {
                const { linkTitle, linkUrl, linkID, linkTarget, dataLinkInfo } = getLinkDetailsEnterprise(link, 'header');
                if (index >= midIndex) return null;
                return (
                  <a key={link?.uid || index} id={linkID} className="action-link trackContent" href={linkUrl} target={linkTarget}  data-link-info={dataLinkInfo}>{linkTitle}</a>
                );
              })}
            </div>
            <div className="action-column">
              {restLocationLinks?.map((link, index) => {
                const { linkTitle, linkUrl, linkID, linkTarget, dataLinkInfo } = getLinkDetailsEnterprise(link, 'header');
                if (index < midIndex) return null;
                return (
                  <a
                    key={link?.uid || index}
                    id={linkID}
                    className="action-link trackContent"
                    href={linkUrl}
                    target={linkTarget}
                    
                    data-link-info={dataLinkInfo}>{linkTitle}</a>
                );
              })}
            </div>
          </div>
          <div className="row mx-auto w-100 location-dropdown__cta">
            <div className="col-12">
              {mobileChangeLocationLink?.map((link, index) => {
                const { linkTitle, linkUrl, linkID, linkTarget, dataLinkInfo } = getLinkDetailsEnterprise(link, 'header');
                return (
                  <a
                    key={link?.uid || index}
                    id={linkID}
                    className="btn find-location-btn location-selected-btn trackContent"
                    href={linkUrl}
                    target={linkTarget}
                    
                    data-link-info={dataLinkInfo}>
                    <span
                      className="ae-compliance-indent sr-only"
                      style={{ display: "none" }}
                    >
                      Location information including phone numbers may be
                      found
                    </span>{linkTitle}</a>
                );
              })}
            </div>

          </div>

        </div>

      </div>
      <div className="select-location" id="mobile-no-location-selected" style={{ display: 'none' }}>
        <div className="row mx-auto">

          {mobileSelectLocationLink?.map((link, index) => {
            const { linkTitle, linkUrl, dataLinkInfo, linkTarget, linkID } = getLinkDetailsEnterprise(link, 'header');
            return (
              <div className="col-12 col-sm-10 col-lg-12 mx-auto text-center" key={link?.uid || index}>
                <a href={linkUrl}
                  
                  target={linkTarget}
                  id={linkID}
                  className="btn btn--green btn-large trackContent no-location-selected-btn"
                  data-link-info={dataLinkInfo}>
                  <span
                    className="ae-compliance-indent sr-only"
                    style={{ display: "none" }}
                  >
                    Location information including phone numbers may be
                    found
                  </span>
                  {toTitleCase(linkTitle)}</a>
              </div>


            );
          })}



        </div>


      </div>

    </div>
  );
};

export default MobileLocationDropdown;
